import FooterComponent from './Footer';

export default FooterComponent;
